import * as Highcharts from "highcharts";

export const chartData = {
  chart: {
    zoomType: "xy"
  },
  legend: {
    itemStyle: {
      color: "#6b778c",
      fontWeight: "normal"
    }
  },
  title: {
    text: "",
    align: "left",
    style: {
      fontWeight: "bold"
    }
  },
  xAxis: [
    {
      categories: ["North", "South", "East", "West"],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis 
      min: 0,
      max: 110,
      labels: {
        format: "{value}%",
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      title: {
        text: "Percentage",
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    },
    {
      // Secondary yAxis
      title: {
        text: "Volume",
        style: {
          color: Highcharts.getOptions().colors[0]
        }
      },
      labels: {
        format: "{value} crore",
        style: {
          color: Highcharts.getOptions().colors[0]
        }
      },
      opposite: true
    }
  ],
  tooltip: {
    shared: true,
    useHTML: true,
    headerFormat: '<table style="min-width:80px">',
    pointFormat:
      "" +
      '<tr><td style="text-transform: capitalize;">{point.name} </td>' +
      '<td style="text-align: right"><b>{point.percentage:.1f}%</b>' +
      "</td></tr>",
    footerFormat: "</table>"
  },

  series: [
    {
      name: "Percentage",
      type: "column",
      data: [49.9, 71.5, 80.4, 92.2],
      tooltip: {
        valueSuffix: "%"
      }
    },

    {
      name: "Volume",
      type: "column",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14],
      tooltip: {
        valueSuffix: "crore"
      }
    }
  ],
  credits: {
    enabled: false
  }
};
